import 'bootstrap';
import './Script';
import React from 'react';
import ReactDOM from 'react-dom';
import Components from './Components';
import $ from 'jquery';
//import validate from 'jquery-validation';
//import unobtrusive from 'jquery-validation-unobtrusive';

// Polyfills for older browsers
import 'whatwg-fetch'
import 'promise-polyfill/src/polyfill';
import "core-js/stable";
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';


function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

$('a.preserve-redirect').each((index, element) => {
    var href = $(element).attr('href');

    var redirectUrl = getUrlParameter('redirect');
    if (redirectUrl) {
        
        $(element).attr('href', href + '?redirect=' + redirectUrl);
    }
});

window.React = React;
window.ReactDOM = ReactDOM;
window.Components = Components;
window.$ = $;
window.jQuery = $;


function setupForms() {
    $(document).on('submit', '.umbraco-forms-form form', function (ev) {

        $(this).find("input[type=submit]").attr('disabled', 'disabled');

        if ($(this).find("input[type=file]").length > 0) {
            return;
        }

        ev.preventDefault();

        var form = this;
        var data = $(this).serialize();

        $(form).addClass('submitted');

        $.post($(this).attr('action'), data, function (result) {
            var resultMessage = $('.umbraco-forms-submitmessage', result);
            if (resultMessage.length > 0) {
                $(form).parent().html(resultMessage[0])
            }
            else {
                $(form).parent().html($('#' + $(form).parent().attr('id') + " form", result)[0])
            }
        });
    });


    //$('.contour').each(function () {
    //    umbracoFormSetup($(this).data('clientid'), $(this).data('formname'));
    //})

    //function umbracoFormSetup(formId, formName) {
    //    var contourFieldValues,
    //        recordValues = JSON.parse($("#values_" + formId).val()),
    //        fsConditions = JSON.parse($("#fsConditions_" + formId).val()),
    //        fieldConditions = JSON.parse($("#fieldConditions_" + formId).val()),
    //        form = $("#contour_form_" + formId);

    //    $(function () {
    //        $(".contourPage input, .contourPage textarea, .contourPage select", form).change(function () {
    //            PopulateFieldValues();
    //            CheckRules();
    //        });

    //        PopulateFieldValues();
    //        CheckRules();
    //    });

    //    function PopulateFieldValues() {
    //        PopulateRecordValues();

    //        $(".contourPage select", form).each(function () {
    //            contourFieldValues[$(this).attr("id")] = $("option[value='" + $(this).val() + "']", $(this)).text();
    //        });

    //        $(".contourPage textarea", form).each(function () {
    //            contourFieldValues[$(this).attr("id")] = $(this).val();
    //        });

    //        $(".contourPage input", form).each(function () {

    //            if ($(this).attr('type') == "text" || $(this).attr("type") == "hidden") {
    //                contourFieldValues[$(this).attr("id")] = $(this).val();
    //            }

    //            if ($(this).attr('type') == "radio") {
    //                if ($(this).is(':checked')) {
    //                    contourFieldValues[$(this).attr("name")] = $(this).val();
    //                }
    //            }

    //            if ($(this).attr('type') == "checkbox") {

    //                if ($(this).attr('id') != $(this).attr('name')) {
    //                    if ($(this).is(':checked')) {
    //                        if (contourFieldValues[$(this).attr("name")] == null) {
    //                            contourFieldValues[$(this).attr("name")] = $(this).val();
    //                        }
    //                        else {
    //                            contourFieldValues[$(this).attr("name")] += "," + $(this).val();
    //                        }
    //                    }
    //                } else {

    //                    contourFieldValues[$(this).attr("name")] = $(this).is(':checked').toString();
    //                }
    //            }

    //        });
    //    }

    //    function PopulateRecordValues() {
    //        var fieldId;
    //        contourFieldValues = new Array();

    //        for (fieldId in recordValues) {
    //            if ($("#" + fieldId).length === 0) {
    //                contourFieldValues[fieldId] = recordValues[fieldId];
    //            }
    //        }
    //    }

    //    function CheckRules() {
    //        umbracoForms.conditions.handle({
    //            fsConditions: fsConditions,
    //            fieldConditions: fieldConditions,
    //            values: contourFieldValues
    //        });
    //    }
    //}
}

$(document).ready(function () {
    setupForms();
});

